/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../../Fixes';
import Builder from '../../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rst": {
                            "nested": {
                              "common": {
                                "nested": {
                                  "Appearance": {
                                    "fields": {
                                      "userInterfaceStyle": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.Appearance.UserInterfaceStyle",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": "DEFAULT"
                                        }
                                      }
                                    },
                                    "nested": {
                                      "UserInterfaceStyle": {
                                        "values": {
                                          "DEFAULT": 0,
                                          "LIGHT": 1,
                                          "DARK": 2
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.Appearance && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.Appearance?.nested?.UserInterfaceStyle) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE Appearance @ squareup/devicesettings/profiles/v2/model/settings/rst/common/appearance.proto at 17:1
 */
export const Appearance = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.common.Appearance');
fixType(Appearance);
Builder.createAndAttachToType(Appearance);
/**
 * SOURCE UserInterfaceStyle @ squareup/devicesettings/profiles/v2/model/settings/rst/common/appearance.proto at 18:3
 */
Appearance.UserInterfaceStyle = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.rst.common.Appearance.UserInterfaceStyle').values;